export default __webpack_public_path__ + "static/media/omniArrow.0d9dfbf5.svg";